import { render, staticRenderFns } from "./SlidingCard.vue?vue&type=template&id=062e5c06&scoped=true&"
import script from "./SlidingCard.vue?vue&type=script&lang=js&"
export * from "./SlidingCard.vue?vue&type=script&lang=js&"
import style0 from "./SlidingCard.vue?vue&type=style&index=0&id=062e5c06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062e5c06",
  null
  
)

export default component.exports